import React from 'react';
import { Code2, Shield, Lightbulb } from 'lucide-react';
import { whatIDo } from '../data/mock';

const icons = [Code2, Shield, Lightbulb];

const WhatIDo = () => {
  return (
    <section
      id="what-i-do"
      className="py-16 md:py-20 px-6 border-b border-stone-400/25 dark:border-stone-500/20"
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 dark:text-stone-100 mb-8">
          What I do
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {whatIDo.map((col, i) => {
            const Icon = icons[i];
            return (
              <div
                key={col.title}
                className="rounded-2xl border border-stone-200 dark:border-stone-800 bg-stone-50/80 dark:bg-stone-900/40 p-5"
              >
                <div className="flex items-center gap-2 mb-1">
                  <Icon className="w-4 h-4 text-amber-800 dark:text-amber-500" />
                  <span className="text-xs font-semibold uppercase tracking-wider text-stone-500 dark:text-stone-400">
                    {col.subtitle}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-stone-900 dark:text-stone-100 mb-3">{col.title}</h3>
                <ul className="space-y-2 text-sm text-stone-600 dark:text-stone-300">
                  {col.bullets.map((b) => (
                    <li key={b} className="flex gap-2">
                      <span className="text-amber-700 dark:text-amber-500 shrink-0">·</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;
